// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"432":"d101c76f","536":"33af1477","912":"1b0d96f0"}[chunkId] + ".chunk.js";
};